import React from "react";

export default function SimilarAthleteFiltersDropdown({
  open,
  setOpen,
  onOpen,
  filters,
  onToggle,
  onApply,
}) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => (open ? setOpen(false) : onOpen())}
        className="text-sm flex items-center gap-2 border border-gray-300 bg-gray-200 rounded-md px-3 py-2"
      >
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 2v1.67l-5 4.759V14H6V8.429l-5-4.76V2h14zM7 8v5h2V8l5-4.76V3H2v.24L7 8z"
          />
        </svg>
        <span className="font-normal">Similar athletes</span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 z-50 w-48 bg-white border rounded-md shadow-lg">
          <div className="p-4 divide-y divide-solid">
            <label className="flex items-center gap-2 text-sm py-2">
              <input
                type="checkbox"
                checked={filters.size}
                onChange={() => onToggle("size")}
              />
              Size
            </label>

            <label className="flex items-center gap-2 text-sm py-2">
              <input
                type="checkbox"
                checked={filters.athleticism}
                onChange={() => onToggle("athleticism")}
              />
              Athleticism
            </label>

            <label className="flex items-center gap-2 text-sm py-2">
              <input
                type="checkbox"
                checked={filters.position}
                onChange={() => onToggle("position")}
              />
              Position
            </label>

            <button
              type="button"
              className="mt-2 w-full bg-red-500 hover:bg-red-600 text-white text-sm py-2 rounded-md"
              onClick={onApply}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
